export const ETournamentStatus = {
  Active: 'active',
  Ended: 'ended',
  Upcoming: 'upcoming',
} as const;
export type TTournamentStatus = (typeof ETournamentStatus)[keyof typeof ETournamentStatus];

export const ETournamentType = {
  Regular: 1,
  Weekly: 2,
  Monthly: 3,
} as const;
export type TTournamentType = (typeof ETournamentType)[keyof typeof ETournamentType];

export const ETournamentEvents = {
  CardClicked: 'tournament-card-click',
  TournamentClicked: 'tournament-click',
  CountdownTick: 'tournament-countdown-tick',
  CountdownCompleted: 'tournament-countdown-completed',
} as const;
export type TTournamentEvents = (typeof ETournamentEvents)[keyof typeof ETournamentEvents];

export interface ITournamentData {
  tournamentId: string;
  tournamentName: string;
  tournamentType: TTournamentType;
  status: TTournamentStatus;
  gameName: string;
  gameId: number;
  isParticipating: boolean;
  prize: number;
  timeLeft: number;
  rewards: number[];
  startsAtString: string;
  endsAtString: string;
  winners: {
    key: string;
    username: string;
    rank: number;
    prize: string;
  }[];
  gameType?: string;
}

export interface ITournamentPrizeData {
  rank: string;
  prize: string;
}

export interface ITournamentLeaderboardItem {
  userId: string;
  username: string;
  key: string;
  rank: number;
  prize: string;
  score: string;
}

export interface IGetActiveTournamentsResponse {
  hasError: boolean;
  list: ITournamentData[];
}

export interface ITournamentRewardData {
  id: string;
  rank: string;
  tournamentName: string;
  amount: number;
}

export interface ITournamentLeaderboardResponse {
  hasError: boolean;
  data: ITournamentLeaderboardItem[];
}

export interface IGetTournamentRewardsResponse {
  hasError: boolean;
  data: ITournamentRewardData[];
}

export interface ITournamentDetailedData {
  id: string;
  tournamentName: string;
  tournamentType: TTournamentType;
  prize: number;
  rewards: number[];
  tillStart: number;
  tillEnd: number;
  startAt: string;
  endAt: string;
  gameId: number;
  gameName: string;
  isParticipating: boolean;
  winners: ITournamentWinner[];
}

export interface ITournamentWinner {
  score: number;
  tournamentId: string;
  userDisplayName: string;
  userId: string;
}

export interface ITournamentDetailedData {
  id: string;
  tournamentName: string;
  prize: number;
  rewards: number[];
  tillStart: number;
  tillEnd: number;
  startAt: string;
  endAt: string;
  gameId: number;
  gameName: string;
  isParticipating: boolean;
  winners: ITournamentWinner[];
}

export interface IActiveTournamentsResponse {
  hasError: boolean;
  data: ITournamentDetailedData[];
}
